/**
 * Sampling Boost правила (ТЗ №39): requested_interval_sec > 0,
 * release_delay_sec 0..3600 (по умолчанию 10).
 */

export const BOOST_DEFAULT_RELEASE_DELAY_SEC = 10;
export const BOOST_MAX_RELEASE_DELAY_SEC = 3600;

const isWhole = (raw) => raw !== '' && raw !== null && raw !== undefined && Number.isInteger(Number(raw));

export const boostFromResponse = (response) => {
  if (!response) {
    return { enabled: false, requestedIntervalSec: '', releaseDelaySec: String(BOOST_DEFAULT_RELEASE_DELAY_SEC) };
  }
  const interval = response.requested_interval_sec;
  const delay = response.release_delay_sec;
  return {
    enabled: Boolean(response.enabled),
    requestedIntervalSec: interval === null || interval === undefined ? '' : String(interval),
    releaseDelaySec: delay === null || delay === undefined ? String(BOOST_DEFAULT_RELEASE_DELAY_SEC) : String(delay),
  };
};

export const boostToRequest = (form) => ({
  enabled: true,
  requested_interval_sec: Number(form.requestedIntervalSec),
  release_delay_sec: Number(form.releaseDelaySec),
});

/** Текст ошибки или null. Выключенный блок не проверяется. */
export const validateBoost = (form) => {
  if (!form?.enabled) return null;
  if (!isWhole(form.requestedIntervalSec) || Number(form.requestedIntervalSec) <= 0) {
    return 'Интервал ускоренной детекции — целое число секунд больше нуля';
  }
  if (!isWhole(form.releaseDelaySec)
    || Number(form.releaseDelaySec) < 0
    || Number(form.releaseDelaySec) > BOOST_MAX_RELEASE_DELAY_SEC) {
    return 'Удержание ускорения — целое число секунд от 0 до 3600';
  }
  return null;
};

export const formatBoostShort = (config) => {
  if (!config?.enabled) return 'Выкл';
  const interval = config.requested_interval_sec;
  if (interval === null || interval === undefined || interval === '') return 'Вкл';
  return `Вкл ${interval} с`;
};

/**
 * Какой отдельный запрос нужен после сохранения core-правила: PUT при
 * включённом и изменённом ускорении, DELETE при выключении ранее включённого,
 * null — когда ничего не поменялось. baseline — последняя сохранённая
 * конфигурация (ответ GET/PUT) или null.
 */
export const planBoostSave = (form, baseline) => {
  if (form?.enabled) {
    const body = boostToRequest(form);
    const unchanged = Boolean(baseline?.enabled)
      && Number(baseline.requested_interval_sec) === body.requested_interval_sec
      && Number(baseline.release_delay_sec) === body.release_delay_sec;
    return unchanged ? null : { type: 'put', body };
  }
  return baseline?.enabled ? { type: 'delete' } : null;
};
